var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".item[data-v-d84a925a]:nth-child(odd){background-color:#eee}.category-head[data-v-d84a925a]{padding-bottom:20px;background-image:url(" + escape(require("../../assets/wood_head.png")) + ");background-repeat:no-repeat;background-size:100% 100%;color:#eee}.category[data-v-d84a925a]{margin-bottom:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-d84a925a","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/karte/KarteCategory.vue
// module id = 61
// module chunks = 0